import { api } from './api';

const clubURL = '/club';

export const clubApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllClub: builder.query({
      query: ({ page = 1, limit = 10, campId = null, name = '', director = '', affiliatedTo = null, status = null } = {}) => {
        const params = { page, limit };
        if (campId)       params.campId = campId;
        if (name)         params.name = name;
        if (director)     params.director = director;
        if (affiliatedTo) params.affiliatedTo = affiliatedTo;
        if (status !== null) params.status = status;
        return { url: clubURL, params };
      },
      providesTags: ['Club'],
    }),
    createClub: builder.mutation({
      query: body => {
        return {
          url: clubURL,
          method: 'POST', // PUT, POST
          body,
        };
      },
      invalidatesTags: ['Club'],
    }),
    getClubById: builder.query({
      query: ({ id }) => `${clubURL}/${id}`,
    }),
    updateClub: builder.mutation({
      query: body => {
        return {
          url: `${clubURL}/${body._id}`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: ['Club'],
    }),
    importClubs: builder.mutation({
      query: ({ clubs, campId }) => ({
        url: `${clubURL}/import`,
        method: 'POST',
        body: { clubs, campId },
      }),
      invalidatesTags: ['Club'],
    }),
  }),
});

export const {
  useGetAllClubQuery,
  // Las etiquetas QR necesitan el listado entero y el controller topa `limit` en 100:
  // con la versión lazy se piden las páginas en bucle sin montar un hook por página.
  useLazyGetAllClubQuery,
  useCreateClubMutation,
  useGetClubByIdQuery,
  useUpdateClubMutation,
  useImportClubsMutation,
} = clubApi;
